/** Formato da API GET /api/crm-funil/etapas (fallback se a requisição falhar). */
export type CrmFunilEtapaApi = {
  id: string;
  titulo: string;
  ordem: number;
  color: string;
  customBgColor?: string;
  categories?: string[];
};

export const DEFAULT_FUNIL_ETAPAS_API: CrmFunilEtapaApi[] = [
  { id: 'lead-capturado', titulo: 'LEAD CAPTURADO', ordem: 1, color: 'bg-blue-100 text-blue-800' },
  {
    id: 'qualificacao',
    titulo: 'QUALIFICAÇÃO DE LEAD',
    ordem: 2,
    color: 'bg-blue-200 text-blue-800',
    categories: ['Perfil Ideal', 'Perfil Secundário', 'Desqualificado'],
  },
  {
    id: 'analise-necessidades',
    titulo: 'ANÁLISE DE NECESSIDADES E CONSIDERAÇÕES',
    ordem: 3,
    color: 'bg-blue-300 text-white',
    categories: ['Clientes Residenciais', 'Clientes Industriais/Comerciais'],
  },
  {
    id: 'proposta-valor',
    titulo: 'PROPOSTA DE VALOR',
    ordem: 4,
    color: 'bg-blue-400 text-white',
    categories: ['Clientes Residenciais', 'Clientes Industriais/Comerciais'],
  },
  {
    id: 'visita-tecnica',
    titulo: 'VISITA TÉCNICA',
    ordem: 5,
    color: 'bg-blue-500 text-white',
    categories: ['Clientes Residenciais', 'Clientes Industriais/Comerciais'],
  },
  {
    id: 'negocio-fechado',
    titulo: 'NEGÓCIO FECHADO',
    ordem: 6,
    color: 'bg-blue-600 text-white',
    categories: ['Clientes Residenciais', 'Clientes Industriais/Comerciais'],
  },
  { id: 'follow-up', titulo: 'FOLLOW-UP', ordem: 7, color: 'text-white', customBgColor: '#78B478' },
  {
    id: 'leads-perdidos',
    titulo: 'LEADS PERDIDOS',
    ordem: 8,
    color: 'bg-red-300 text-red-800',
    categories: ['Leads Desqualificados', 'Negócios Perdidos'],
  },
];

/** Fallback do funil de prospecção de parcerias (GET etapas com `crm_funil=parceiro_prospeccao`). */
export const DEFAULT_FUNIL_ETAPAS_PARCERIA_API: CrmFunilEtapaApi[] = [
  { id: 'parceiro-prospeccao-inicial', titulo: 'PROSPECÇÃO INICIAL', ordem: 1, color: 'bg-violet-100 text-violet-900' },
  { id: 'parceiro-contato-realizado', titulo: 'CONTATO REALIZADO', ordem: 2, color: 'bg-violet-200 text-violet-900' },
  { id: 'parceiro-reuniao-apresentacao', titulo: 'REUNIÃO / APRESENTAÇÃO', ordem: 3, color: 'bg-violet-300 text-white' },
  { id: 'parceiro-proposta-parceria', titulo: 'PROPOSTA DE PARCERIA', ordem: 4, color: 'bg-violet-400 text-white' },
  { id: 'parceiro-negociacao', titulo: 'NEGOCIAÇÃO', ordem: 5, color: 'bg-violet-500 text-white' },
  { id: 'parceiro-parceria-firmada', titulo: 'PARCERIA FIRMADA', ordem: 6, color: 'bg-emerald-600 text-white' },
  { id: 'parceiro-follow-up', titulo: 'FOLLOW-UP', ordem: 7, color: 'text-white', customBgColor: '#7c6fd6' },
  { id: 'parceiro-sem-interesse', titulo: 'SEM INTERESSE / ENCERRADO', ordem: 8, color: 'bg-red-200 text-red-900' },
];
